<template>
  <div class="row">
    <div class="col-12">
      <div class="custom-header-three d-flex justify-content-around align-items-end" v-bind:style="{color:this.settings_style.colors != undefined? this.settings_style.colors[5].color_value: 'white',}">
        <div>
          <p class="my-0" v-if="this.settings_style.view_folio">
            <span v-if="quote_data != undefined">
              <b>Cotización:</b> #{{ quote_data.details.folio }}
            </span>
            <span v-else> <b>Cotización:</b> #Folio </span>
          </p>
          <p class="my-0" v-if="this.settings_style.view_date_send">
            <span v-if="quote_data != undefined">
              <b>Fecha de envío:</b> {{ quote_data.details.date_send }}
            </span>
            <span v-else> <b>Fecha de envío:</b> Fecha de envio </span>
          </p>
        </div>
        <div class="mx-auto">
          <img
            class="company-logo"
            v-bind:src="(this.settings_style.logo != null && this.settings_style.logo != undefined && this.settings_style.logo != 'null') ? this.settings_style.logo : this.image_white"
            v-if="this.settings_style.logo != ''"
            
          />
        </div>
        <div>
          <p class="my-0" v-if="this.settings_style.view_date_validity">
            <span v-if="quote_data != undefined">
              <b>Validez:</b> {{ quote_data.details.date_valid }}
            </span>
            <span v-else> <b>Validez:</b> Validez </span>
          </p>
          <p class="my-0" v-if="this.settings_style.view_currency">
            <span v-if="quote_data != undefined">
              <b>Moneda:</b> {{ quote_data.details.currency }}
            </span>
            <span v-else> <b>Moneda:</b> Moneda </span>
          </p>
        </div>
      </div>
      <hr style="margin: 0 60px; background-color:#929497;">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    settings_style: {
      required: true,
    },
    quote_data: {
      type: Object,
    },
  },
  data(){
    return{
      image_white : null
    }
  },
  mounted(){
    this.image_white =  require("@/assets/images/white_default.jpg")
  }
};
</script>